<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card width="100%" height="100%">
          <v-card-title primary-title>
            Catálogo de Usuarios
            <v-spacer></v-spacer>

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar Usuarios"
              single-line
              hide-details
            ></v-text-field>

            <v-spacer></v-spacer>

            <!-- IMPPORTACION MASIVA -->
            <v-btn
              align="right"
              color="red"
              dark
              small
              class="ma-2"
              :to="{ name: 'altamasivausr' }"
              >Importacion masiva
            </v-btn>

            <!-- NUEVO -->
            <v-btn
              align="right"
              color="orange"
              dark
              small
              class="ma-2"
              :to="{ name: 'newusuario2' }"
              >Nuevo
            </v-btn>

            <!-- EXCEL -->
            <v-btn align="right" class="ma-2" small color="green" dark>
              <download-excel
                :data="usuarios"
                :fields="json_fields"
                worksheet="My Worksheet"
                name="CatUsarios.xls"
              >
                Excel
                <v-icon class="ma-1">mdi-download</v-icon>
              </download-excel>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="usuarios"
              class="elevation-1"
              fixed-header
              height="450"
              hide-default-footer
              loading-text="Cargando..."
              dense
              :search="search"
              :items-per-page="longitud"
              calculate-widths
            >
              <template v-slot:item="{ item }">
                <tr v-on:dblclick.prevent.stop="editar(item)">
                  <!-- <td>{{ item.idusuariosweb }}</td> -->
                  <td>{{ item.nomuser }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.nomina }}</td>
                  <td>{{ item.nivel }}</td>
                  <td>{{ item.nomplanta }}</td>
                  <td>{{ item.nomarea }}</td>

                  <td>{{ item.planta }}</td>
                  <td>{{ item.area }}</td>

                  
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  data: () => ({
    dialog: false,
    headers: [
      // { text: "ID", align: "left", sortable: false, value: "idusuariosweb" },
      { text: "Nombre", value: "nomuser" },
      { text: "Email", value: "email" },
      { text: "No. Nomina", value: "nomina" },
      { text: "Nivel", value: "nivel", align: "right" },
      { text: "Planta", value: "planta" },
      { text: "Area", value: "area" },
      { text: "Planta", value: "planta" },
      { text: "Area", value: "area" },


    ],
    usuarios: [],
    search: "",
    loading: false,
    longitud: 0,

    json_fields: {
      Id: "idusuario",
      Nombre: "nomuser",
      email: "email",
      Planta: "planta",
      Area: "area",
      Nomina: "nomina",
      Nivel: "nivel",
    },
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    json_data: [],
  }),
  created() {
    this.init();
  },

  methods: {
    getColor(estatus) {
      if (estatus > 1) return "green";
      else if (estatus > 2) return "orange";
      else return "red";
    },

    editar(item) {
      console.log("item", item);

      this.$router.push({ name: "newusuario2", params: item });
    },

    init() {
      //Consultar Usuarios
      this.loading = true;

      this.$http
        .get("v2/listusuarios")
        .then((response) => {
          // console.log(response.data)
          this.usuarios = response.data.result;
          this.longitud = response.data.result.length;

          // this.longitud= this.Docum.length
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>